import CloseIcon from '@mui/icons-material/Close'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import TextareaAutosize from '@mui/material/TextareaAutosize'

import { StyledIconButton } from '../../../theme/components/StyledIconButton'
import type { JobSchedule } from '../../types/JobSchedule'

interface Props {
  jobSchedule: JobSchedule
  onClose: () => void
}

const MESSAGE_INDENT = 2

const parse = (content: Record<string, any>) =>
  content && JSON.stringify(content, null, MESSAGE_INDENT)

export const JobScheduleData = ({ jobSchedule, onClose }: Props) => {
  const { data } = jobSchedule

  return (
    <Drawer
      anchor="right"
      open={true}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            width: '600px',
            maxWidth: '90vw',
            p: 1,
          },
        },
      }}
    >
      <Box>
        <StyledIconButton
          icon={<CloseIcon />}
          title="Sluiten"
          onClick={onClose}
        />
      </Box>
      <TextareaAutosize minRows={10} maxRows={40} value={parse(data)} />
    </Drawer>
  )
}
